import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { UserExclamationIcon } from '@calendly/ui/components/icons'

const NoInviteesWarning = () => (
  <>
    <UserExclamationIcon size="standard" />
    {I18n.t('publisher.event_types.group.invitee_limit.warning')}
  </>
)

export const Summary = () => {
  const { values: { inviteesLimit } } = useFormContext()

  return inviteesLimit
    ? I18n.t('publisher.event_type_editor.sections.hosts_and_invitees.group_event_summary', { count: inviteesLimit })
    : <NoInviteesWarning />
}
